// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3LLT-","container":"styles_container__3rvJX","title":"styles_title__1FBlB","wrapper":"styles_wrapper__2i1Pd","answer":"styles_answer__2Cfvf"};